import React from "react";
import { NotificationsStore } from "..";

export const NotificationsStoreContext =
  React.createContext<NotificationsStore | null>(null);

export const NotificationsStoreProvider: React.FC = (props) => {
  const store = new NotificationsStore();

  return (
    <NotificationsStoreContext.Provider value={store}>
      {props.children}
    </NotificationsStoreContext.Provider>
  );
};

export const useNotificationsStore = (): NotificationsStore => {
  const store = React.useContext(NotificationsStoreContext);
  if (store) return store;

  throw new Error(
    "useNotificationsStore must be used witin a NotificationsStoreProvider"
  );
};
